import { PageLoader } from "@bidbattles/bloks/components/ui/loading";
import { usePayments } from "@/lib/backend/payments";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/callbacks/payment")({
	component: RouteComponent,
});

function RouteComponent() {
	const payments = usePayments();

	useEffect(() => {
		payments.notifyShouldGrabFocus();
	}, [payments.notifyShouldGrabFocus]);

	return (
		<PageLoader>
			<p>Please wait... You'll be taken back to continue where you left off.</p>
		</PageLoader>
	);
}
